import React from 'react';
import { SectionWrapper } from './ui/SectionWrapper';
import { HelpCircle, Scale } from 'lucide-react';
export function FAQSection() {
  const faqs = [{
    q: '¿Es difícil de entender?',
    a: 'No. Está hecho para padres sin conocimientos técnicos.'
  }, {
    q: '¿Sirve para cualquier edad?',
    a: 'Sí, especialmente de 8 a 16 años.'
  }, {
    q: '¿Cómo lo recibo?',
    a: 'Por email, en formato PDF.'
  }, {
    q: '¿Es aplicable en Argentina?',
    a: 'Sí, está adaptado a la realidad actual.'
  }];
  return <>
      <SectionWrapper data-id="element-11">
        <div className="text-center mb-8 md:mb-12" data-id="element-12">
          <div className="inline-flex items-center justify-center bg-brand-darkCard border border-slate-700 p-3 md:p-4 rounded-full mb-4 md:mb-6" data-id="element-13">
            <HelpCircle className="w-6 h-6 md:w-8 md:h-8 text-blue-400" data-id="element-14" />
          </div>
          <h2 className="text-2xl md:text-4xl font-extrabold text-white" data-id="element-15">
            PREGUNTAS FRECUENTES
          </h2>
        </div>

        <div className="max-w-3xl mx-auto space-y-3 md:space-y-4" data-id="element-16">
          {faqs.map((faq, i) => <div key={i} className="bg-white shadow-lg rounded-xl md:rounded-2xl p-5 md:p-8" data-id="element-17">
              <h4 className="text-base md:text-xl font-bold text-brand-navy mb-2 md:mb-3" data-id="element-18">
                {faq.q}
              </h4>
              <p className="text-sm md:text-lg text-brand-text" data-id="element-19">{faq.a}</p>
            </div>)}
        </div>
      </SectionWrapper>

      <SectionWrapper className="bg-brand-darkAlt border-y border-slate-800" data-id="element-20">
        <div className="max-w-3xl mx-auto" data-id="element-21">
          <div className="text-center mb-8 md:mb-12" data-id="element-22">
            <Scale className="w-10 h-10 md:w-12 md:h-12 text-slate-500 mx-auto mb-4 md:mb-6" data-id="element-23" />
            <h2 className="text-2xl md:text-4xl font-extrabold text-white" data-id="element-24">
              ¿CUÁNTO CUESTA NO HACER NADA?
            </h2>
          </div>

          <div className="grid md:grid-cols-2 gap-4 md:gap-8" data-id="element-25">
            <div className="bg-white shadow-lg rounded-xl md:rounded-2xl p-5 md:p-8" data-id="element-26">
              <h4 className="text-lg md:text-xl font-bold text-brand-navy mb-4 md:mb-6" data-id="element-27">
                Sin este sistema:
              </h4>
              <ul className="space-y-3 md:space-y-4 mb-5 md:mb-8" data-id="element-28">
                {['Seguís sin saber qué pasa en el celular', 'Reaccionás tarde', 'No tenés herramientas', 'Dependés de la suerte'].map((item, i) => <li key={i} className="flex items-start gap-2 md:gap-3 text-sm md:text-base text-brand-text" data-id="element-29">
                    <span className="text-red-500 font-bold" data-id="element-30">❌</span> {item}
                  </li>)}
              </ul>
              <p className="text-base md:text-xl font-bold text-red-500" data-id="element-31">
                👉 Y el riesgo sigue ahí.
              </p>
            </div>

            <div className="bg-blue-50 border border-blue-200 rounded-xl md:rounded-2xl p-5 md:p-8" data-id="element-32">
              <h4 className="text-lg md:text-xl font-bold text-brand-blue mb-4 md:mb-6" data-id="element-33">
                💡 EL CAMBIO
              </h4>
              <p className="text-sm md:text-base text-brand-text mb-4 md:mb-6" data-id="element-34">
                No se trata de controlar todo.
                <br data-id="element-35" />
                Se trata de:
              </p>
              <div className="space-y-3 md:space-y-4" data-id="element-36">
                <p className="text-base md:text-xl font-bold text-brand-navy flex items-center gap-2" data-id="element-37">
                  <span className="text-brand-blue" data-id="element-38">👉</span> entender
                </p>
                <p className="text-base md:text-xl font-bold text-brand-navy flex items-center gap-2" data-id="element-39">
                  <span className="text-brand-blue" data-id="element-40">👉</span> acompañar
                </p>
                <p className="text-base md:text-xl font-bold text-brand-navy flex items-center gap-2" data-id="element-41">
                  <span className="text-brand-blue" data-id="element-42">👉</span> proteger
                </p>
              </div>
            </div>
          </div>
        </div>
      </SectionWrapper>
    </>;
}